import { SelectOption } from 'govwell-ui/components/Select/types'
import { CompanyFragment } from 'types/graphql'

import CompanySelect from 'src/components/Selects/CompanySelect'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: string
  companies: CompanyFragment[]
  field: TanstackField<CompanyFragment | undefined, TKey>
  getIsOptionDisabled?: (option: SelectOption<CompanyFragment>) => boolean
  isRequired?: boolean
  label?: string
  placeholder?: string
}

const CompanySelectField = <TKey extends string>({
  caption,
  companies,
  field,
  getIsOptionDisabled,
  isRequired,
  label,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = !!errorMessage
  return (
    <CompanySelect
      caption={caption}
      companies={companies}
      errorMessage={errorMessage}
      getIsOptionDisabled={getIsOptionDisabled}
      isInvalid={isInvalid}
      isRequired={isRequired}
      label={label}
      onBlur={field.handleBlur}
      onValueChange={field.setValue}
      value={field.state.value}
    />
  )
}

export default CompanySelectField
